import React, {useEffect, useRef, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
const IpLabEntry = (props) => {
    const {pat_id} = useParams();
    const {ip_id} = useParams();
    const [patientData, setPatientData] = useState([]);
    const [consData, setConsData] = useState([]);
    const [ipData, setIpData] = useState([]);
    const [items, setItems] = useState([]);
    const [rows, setRows] = useState([{ID: '', Subcat: '', Amount: ''}]);
    const [total, setTotal] = useState(0);
    const [subtotal, setSubTotal] = useState(0);
    const [disPer, setDisPer] = useState(0);
    const [disAmount, setDisAmount] = useState(0);
    const inputRefs = useRef([]);
    const [labData, setLabData] = useState({
        "appt_id": '',
        "ip": '',
        "pat": '',
        "cons": '',
        "lab_id": '',
        "ltest_id": '',
        "lab_test": '',
        "lab_amount": '',
        "lab_tot": '',
        "lab_disc": '',
        "lab_status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [patResponse, labResponse, consResponse, ipResponse] = await Promise.all([
                    axios.get(`${baseUrl}pat-id/${pat_id}/`),
                    axios.get(`${baseUrl}lab-search/`),
                    axios.get(`${baseUrl}cons-search/`),
                    axios.get(`${baseUrl}edit-ip-admit/${ip_id}/`),
                ]);
                if (patResponse.status === 200 || patResponse.status === 201) {
                    setPatientData(patResponse.data);
                } else {
                    window.location.href = '/pat-search/';
                }
                setItems(labResponse.data);
                setConsData(consResponse.data);
                setIpData(ipResponse.data);
            } catch (error) {
                console.log(error);
            }
        };
        fetchData();
    }, []);
    const handleKeyDown = (e, index) => {
        const newRows = [...rows];
        switch (e.keyCode) {
            // Handle Shift key
            case 16:
                e.preventDefault();
                if (index === rows.length - 1) {
                    newRows.push({id: '', subcat: '', amount: ''});
                }
                break;
            // Handle arrow up key
            case 90:
                e.preventDefault();
                newRows.splice(index, 1);
                break;
            case 38:
                e.preventDefault();
                if (newRows[index].selectedItem === 0) {
                    newRows[index].selectedItem = items.length - 1;
                } else {
                    newRows[index].selectedItem--;
                }
                setRows(newRows);
                break;
            // Handle arrow down key
            case 40:
                e.preventDefault();
                if (newRows[index].selectedItem === items.length - 1) {
                    newRows[index].selectedItem = 0;
                } else {
                    newRows[index].selectedItem++;
                }
                setRows(newRows);
                break;
            default:
                break;
        }
        setRows(newRows);
    };
    const handleSelect = (value, index) => {
        // Check if value is undefined or null
        if (value === undefined || value === null) {
            // Handle the scenario where the value is cleared or backspaced
            const newRows = [...rows];
            newRows[index] = {id: '', subcat: '', amount: ''};
            setRows(newRows);
        } else {
            // Handle the selection
            const selectedItem = items.find(item => item.subcat === value);
            if (selectedItem) {
                const newRows = [...rows];
                // Check if payment is 'Insurance' and apply a 50% hike
                const adjustedAmount = ipData.payment === 'Insurance'
                    ? selectedItem.amount * 1.5
                    : selectedItem.amount;
                newRows[index] = {
                    id: selectedItem.id,
                    subcat: selectedItem.subcat,
                    amount: adjustedAmount
                };
                setRows(newRows);
            }
        }
    };
    const handleAmountChange = (e, index) => {
        const newRows = [...rows];
        newRows[index].amount = parseFloat(e.target.value) || 0;
        setRows(newRows);
    };
    const handleAddRow = () => {
        const newRows = [...rows, {id: '', subcat: '', amount: ''}];
        setRows(newRows);
    };
    useEffect(() => {
        inputRefs.current[inputRefs.current.length - 1]?.focus();
    }, [rows]);
    const handleDeleteRow = (index) => {
        const newRows = [...rows];
        newRows.splice(index, 1);
        setRows(newRows);
    };
    const handleDisPerChange = (e) => {
        const newDisPer = parseFloat(e.target.value) || 0;
        setDisPer(newDisPer);
    };
    useEffect(() => {
        let subTotal = 0;
        let disAmount = 0;
        let newTotal = 0;
        for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            subTotal += row.amount;
            disAmount = subTotal * (parseFloat(disPer) / 100);
            newTotal = subTotal - disAmount;
        }
        setSubTotal(subTotal);
        setDisPer(disPer);
        setDisAmount(disAmount);
        setTotal(newTotal);
    }, [rows, disPer]);
    const consultantOptions = consData.map((cons) => ({
        value: cons.id,
        label: cons.consultant,
    }));
    const handleChange = (event) => {
        const {name, value} = event.target;
        setLabData(prevState => ({...prevState, [name]: value}));
    };
    const handleConsChange = (event, value) => {
        if (value) {
            setLabData(prevState => ({...prevState, cons: value.value}));
        } else {
            setLabData(prevState => ({...prevState, cons: ''}));
        }
    };
    const formSubmit = (e) => {
        e.preventDefault();
        axios.post(`${baseUrl}get_appt_lab_number/`)
            .then(response => {
                const appt_lab = response.data.value;
                const _formData = new FormData();
                if (!labData.cons) {
                    Swal.fire('Error', 'Please select a consultant.', 'error');
                    return;
                }
                _formData.append('appt_id', appt_lab);
                _formData.append('ip', ip_id);
                _formData.append('pat', patientData[0].id);
                _formData.append('cons', labData.cons.value);
                _formData.append('lab_id', appt_lab);
                _formData.append('ltest_id', rows.map(row => row.id).join(','));
                _formData.append('lab_test', rows.map(row => row.subcat).join(','));
                _formData.append('lab_amount', rows.map(row => row.amount).join(','));
                _formData.append('lab_tot', total);
                _formData.append('lab_disc', disAmount.toString());
                _formData.append('lab_status', '1');
                _formData.append('addedby', userName);
                _formData.append('ip_add', ipAddress);
                _formData.append('location', userLocation);
                axios.post(`${baseUrl}ip-lab-create/`, _formData)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            Swal.fire({
                                title: 'Lab entry has been added.',
                                icon: 'success',
                                timer: 2000,
                                showConfirmButton: false
                            });
                            setLabData({
                                appt_id: '',
                                ip: '',
                                pat: '',
                                cons: '',
                                lab_id: '',
                                ltest_id: '',
                                lab_test: '',
                                lab_amount: '',
                                lab_tot: '',
                                lab_disc: '',
                                lab_status: '',
                                addedby: '',
                                ip_add: '',
                            });
                            setRows([{id: '', subcat: '', amount: ''}]);
                            setTotal(0);
                            setSubTotal(0);
                            setDisPer(0);
                            setDisAmount('');
                            setTimeout(() => {
                                window.history.back();
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        Swal.fire(
                            'Error!',
                            'Failed to add lab entry. Please try again later.',
                            'error'
                        );
                    });
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to generate unique value. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <form>
                <div className="row table-responsive">
                    <div className='col-md-12 col-12 mb-2'>
                        <table className="erp-table-modern">
                            <thead>
                            <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                <th>Patient ID</th>
                                <th>Patient Name</th>
                                <th>Gender</th>
                                <th>D.O.B/Age</th>
                                <th>Marital Status</th>
                                <th>Regd. On</th>
                                <th>Consultant</th>
                                <th>Occupation</th>
                            </tr>
                            </thead>

                            <tbody>
                            {patientData.map((patientData, index) => (
                                <tr key={index}>
                                    <td>{patientData.pat_id}</td>
                                    <td>{patientData.patient}</td>
                                    <td>{patientData.gender}</td>
                                    <td>{patientData.age}</td>
                                    <td>{patientData.marital_status}</td>
                                    <td>{patientData.add_date}</td>
                                    <td>
                                        {consData.length > 0 && (
                                            <AutoComplete
                                                id="combo-box-demo"
                                                options={consultantOptions}
                                                getOptionLabel={(option) => option.label}
                                                onChange={(event, value) => setLabData(prevState => ({
                                                    ...prevState,
                                                    cons: value
                                                }))}
                                                renderInput={(params) => (
                                                    <TextField {...params} onChange={handleConsChange} name="cons"/>
                                                )}
                                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                            />
                                        )}
                                    </td>
                                    <td>{patientData.occupation}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Total</th>
                            <th>Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td>
                                    <input
                                        type="text"
                                        className="ms-2 me-5 mt-4"
                                        style={{width: 80}}
                                        name="ltest_id"
                                        value={row.id}
                                        onChange={(e) => handleChange(e, index, 'id')}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <AutoComplete
                                        className="form-control mt-2"
                                        options={items.map(item => item.subcat)}
                                        onChange={(event, value) => handleSelect(value, index)}
                                        onInputChange={(event, newInputValue) => {
                                            // Update input value
                                            setRows(prevRows => {
                                                const updatedRows = [...prevRows];
                                                updatedRows[index].subcat = newInputValue;
                                                return updatedRows;
                                            });
                                        }}
                                        onKeyDown={e => handleKeyDown(e, index)}
                                        renderInput={(params) => (
                                            <div ref={params.InputProps.ref}
                                            >
                                                <input className="form-control" type="text" {...params.inputProps}
                                                       focused autoFocus
                                                       fullWidth
                                                       style={{
                                                           width: 270,
                                                           background: "#F7EEFF",
                                                       }}
                                                />
                                            </div>
                                        )}
                                        ref={(el) => inputRefs.current[index] = el}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        className="ms-2 me-5"
                                        style={{width: 100}}
                                        value={row.amount}
                                        name="amount"
                                        onChange={handleChange}
                                        onChange={(e) => handleAmountChange(e, index)}
                                        readOnly
                                    />
                                </td>
                                <td>
                                    <button className="btn btn-danger" type="button"
                                            onClick={() => handleDeleteRow(index)}>Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <button className="btn btn-success addmore mt-4" type="button" onClick={handleAddRow}>Add More
                    </button>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5'>
                        <div className="form-group">
                            <label style={{fontWeight: 'bold'}}>Subtotal: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" value={subtotal} readOnly/>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label style={{fontWeight: 'bold'}}>Discount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">%</div>
                                <input type="number" value={disPer} name="disPer" id="disPer"
                                       onChange={handleDisPerChange}/>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label style={{fontWeight: 'bold'}}>Discount Amount: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" onChange={handleChange} name="disAmount" id="disAmount"
                                       value={disAmount}/>
                            </div>
                        </div>
                        <div className="form-group mt-3">
                            <label style={{fontWeight: 'bold'}}>Total: &nbsp;</label>
                            <div className="input-group">
                                <div className="input-group-addon me-2 ">&#8377;</div>
                                <input type="number" onChange={handleChange} name="tot" value={total} readOnly/>
                            </div>
                        </div>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>

                    </div>
                </div>
            </form>
        </section>
    );
};
export default IpLabEntry;
